import { DayjsUnit } from '@/models/Dayjs.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

const DOTLESS_DATE_OF_BIRTH_SEARCH_FORMAT = 'DDMMYYYY';
const DATE_OF_BIRTH_SEARCH_FORMAT = 'DD.MM.YYYY';

export const isToday = (date: Date | string): boolean => {
    return dayjs(date).isSame(dayjs(), DayjsUnit.DAY);
};

export const formatDotlessDateOfBirthSearch = (search: string): string | undefined => {
    const trimmedSearch = search.trim();
    const parsedDate = dayjs(trimmedSearch, DOTLESS_DATE_OF_BIRTH_SEARCH_FORMAT, true);
    if (!parsedDate.isValid()) return undefined;

    return parsedDate.format(DATE_OF_BIRTH_SEARCH_FORMAT);
};

export const getDateOfBirthSearchValues = (date: Date | string | undefined): string[] => {
    if (!date) return [];

    const parsedDate = dayjs(date);
    if (!parsedDate.isValid()) return [];

    return [parsedDate.format(DATE_OF_BIRTH_SEARCH_FORMAT), parsedDate.format(DOTLESS_DATE_OF_BIRTH_SEARCH_FORMAT)];
};

export const getPatientSearchQueries = (query: string): string[] => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return [];

    const queryParts = trimmedQuery.split(/\s+/);
    const formattedQueryParts = queryParts.map((part) => formatDotlessDateOfBirthSearch(part) ?? part);
    const formattedQuery = formattedQueryParts.join(' ');
    if (formattedQuery === trimmedQuery) return [trimmedQuery];

    return [trimmedQuery, formattedQuery];
};
